export default "__VITE_PUBLIC_ASSET__e41a7fd7__"